import { render, staticRenderFns } from "./InputPhonePage.vue?vue&type=template&id=52d41a57&scoped=true&"
import script from "./InputPhonePage.vue?vue&type=script&lang=js&"
export * from "./InputPhonePage.vue?vue&type=script&lang=js&"
import style0 from "./InputPhonePage.vue?vue&type=style&index=0&id=52d41a57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d41a57",
  null
  
)

export default component.exports